import { FormatterMode } from "../mode.js";
export const FORMATTER_ROUTE_EXAMPLES = [
    {
        id: "strip-html",
        label: "Strip HTML",
        slug: "strip-html",
        contentType: FormatterMode.Text,
        text: `<h1>Welcome to <em>TextFormatter</em></h1>
<p>Clean <strong>messy</strong> text fast &amp; reliably.</p>
<style>.hidden { display:none; }</style>
<script>console.log("ignore me")</script>
<p>Use this tool to keep only readable text.</p>`,
        transforms: {
            stripHtml: true,
            normalizeWhitespace: true,
        },
    },
    {
        id: "remove-extra-spaces",
        label: "Remove Extra Spaces",
        slug: "remove-extra-spaces",
        contentType: FormatterMode.Text,
        text: `Meeting notes
Project launch   timeline review

Next steps:    finalize copy, update landing page, confirm budget.`,
        transforms: {
            normalizeWhitespace: true,
        },
    },
    {
        id: "lowercase-text",
        label: "Lowercase Text",
        slug: "lowercase-text",
        contentType: FormatterMode.Text,
        text: `WELCOME TO TEXTFORMATTER
THIS EXAMPLE SHOWS HOW TO CONVERT LOUD TEXT INTO A READABLE FORMAT.`,
        transforms: {
            lowercase: true,
        },
    },
    {
        id: "capitalize-text",
        label: "Capitalize Text",
        slug: "capitalize-text",
        contentType: FormatterMode.Text,
        text: `wElcome to textformatter
this line has mixed casing and should be normalized for readability.`,
        transforms: {
            capitalize: true,
        },
    },
    {
        id: "normalize-whitespace-text",
        label: "Normalize Whitespace",
        slug: "normalize-whitespace-text",
        contentType: FormatterMode.Text,
        text: `Team   update		for   Monday
Prepare    release notes   and   QA   checklist.
Confirm  ownership   for   API  docs and   web examples.`,
        transforms: {
            normalizeWhitespace: true,
        },
    },
    {
        id: "normalize-notes",
        label: "Normalize Notes",
        slug: "normalize-notes",
        contentType: FormatterMode.Text,
        text: `daily standup notes
blockers: waiting for design feedback
done: shipped formatter api example section
next: add more plain text format pages for seo`,
        transforms: {
            capitalize: true,
        },
    },
    {
        id: "product-ingredients",
        label: "Product Ingredients",
        slug: "product-ingredients",
        contentType: FormatterMode.Ecommerce,
        options: {
            detectHeadings: true,
            detectLists: false,
            detectColonLabels: true,
            splitAfterSentenceEnd: false,
            nutritionBlockParsing: false,
        },
        text: `Ingredients 1 tablet (1000 mg)

Terminalia chebula* (Haritaki) 358 mg, Emblica officinalis* (Amalaki) 358 mg, Terminalia belerica* (Bibhitaki) 199 mg, Rosa centifolia* 70 mg, starch tapioca* *from organic farming Warning: Do not exceed the recommended daily dosage.

The supplement is not intended as a substitute for a varied diet. Not suitable for children, pregnant and lactating women. Keep out of reach of children, in a dry and dark place. We do not recommend using it for diarrhea.`,
    },
    {
        id: "product-description",
        label: "Product Description",
        slug: "product-description",
        contentType: FormatterMode.Ecommerce,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: true,
            splitAfterSentenceEnd: true,
            nutritionBlockParsing: false,
        },
        text: `Usage

Apply a sufficient amount of oil to the appropriate part of the body and massage in a clockwise direction for five minutes.

Ingredients

Sesame oil (Sesamum indicum seed oil), galangal rhizome extract (Alpinia galanga), Tribulus terrestris extract, cedarwood extract (Cedrus deodara), patala root extract (Stereospermum suaveolens), ashwagandha root extract (Withania somnifera) Caution: Close the cap carefully. Keep out of reach of children. The product is not intended for children or pregnant or breastfeeding women.

Storage
-Store the product in a dry place, at a temperature between 10-25 °C.
-Do not expose to direct sunlight.`,
    },
    {
        id: "product-features-list",
        label: "Product Features List",
        slug: "product-features-list",
        contentType: FormatterMode.Ecommerce,
        options: {
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: false,
            splitAfterSentenceEnd: false,
            nutritionBlockParsing: false,
        },
        text: `Main features
- Water-resistant outer shell.
- Adjustable hood with elastic drawcord.
- Soft inner lining for extra comfort.
- Full-length zipper with chin guard.
- Machine washable material.`,
    },
    {
        id: "product-specifications",
        label: "Product Specifications",
        slug: "product-specifications",
        contentType: FormatterMode.Ecommerce,
        options: {
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: true,
            splitAfterSentenceEnd: false,
            nutritionBlockParsing: false,
        },
        text: `Specifications:
Material: 92% polyester, 8% elastane
Weight: 420 g
Available sizes: S, M, L, XL
Color options: Black, Navy, Olive
Care instructions: Wash at 30°C, do not tumble dry`,
    },
    {
        id: "list-to-html",
        label: "List to HTML",
        slug: "list-to-html",
        contentType: FormatterMode.Web,
        options: {
            detectHeadings: false,
            detectLists: true,
            detectColonLabels: false,
        },
        text: `- If text starts with a dash, it is converted to a list item.
- This allows you to create lists quickly.
- Just paste your text and get clean HTML output.
* List items can also start with an asterisk at the beginning of line.`,
    },
    {
        id: "html-text-formatter",
        label: "HTML Text Formatter",
        slug: "html-text-formatter",
        contentType: FormatterMode.Web,
        options: {
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: false,
        },
        text: `Formatting HTML-ready text
This helper organizes your raw content into headings, paragraphs, and lists.
It keeps structure consistent across pages.
It reduces manual cleanup before publishing.
Use it when you want clean HTML output quickly.`,
    },
    {
        id: "blog-post-formatting",
        label: "Blog Post Formatting",
        slug: "blog-post-formatting",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: false,
        },
        text: `Blog Post Structure

A strong blog post starts with a clear introduction that explains who the article is for and what problem it solves. The opening paragraph should set expectations quickly and give readers a reason to continue.

Core Sections
- Define one key point per section.
- Add practical examples that support each claim.
- Keep paragraphs short for easier scanning.

Editing Checklist
- Verify heading hierarchy from top to bottom.
- Remove repeated phrases and filler sentences.
- Finish with a conclusion that summarizes takeaways and suggests one clear next action.`,
    },
    {
        id: "web-content-formatting",
        label: "Web Content Formatting",
        slug: "web-content-formatting",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: true,
        },
        text: `Web content checklist
- Keep sentences short and direct.
- Highlight key points with bullets.
- Maintain consistent heading hierarchy.
- Remove duplicated spacing and line breaks.
- Keep tone aligned with brand voice.`,
    },
    {
        id: "terms-and-conditions",
        label: "Terms and Conditions",
        slug: "terms-and-conditions",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: false,
            detectColonLabels: true,
        },
        text: `Terms and Conditions\n
Use of service: You agree to use the platform in compliance with applicable laws.
Account responsibility: You are responsible for activity under your account credentials.
Service availability: We may update or suspend features to improve reliability.
Limitation of liability: The service is provided as is without guaranteed uninterrupted operation.`,
    },
    {
        id: "privacy-policy",
        label: "Privacy Policy",
        slug: "privacy-policy",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: false,
            detectColonLabels: true,
        },
        text: `Privacy Policy\n
Data collected: We store account details and usage events required to provide the service.
Purpose of processing: Data is used for authentication, billing, and product improvement.
Retention period: Records are kept only as long as necessary for legal and operational needs.
User rights: You may request access, correction, or deletion of personal data.`,
    },
    {
        id: "plain-text-to-html",
        label: "Plain Text to HTML",
        slug: "plain-text-to-html",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: true,
        },
        text: `Converting plain text to HTML\n
Paste your unformatted draft.
Detect headings and list items automatically.
Generate clean paragraph structure.
Copy final HTML for your CMS or website builder.
Headings are without dots
When a heading is followed by a sentence without new line, it is converted to a list item.
Headings are without dots\n
When a heading and sentence is separated by a new line, it stays a sentence.
- But you can add list with - or *
* You are welcome`,
    },
    {
        id: "real-estate-description",
        label: "Real Estate Description",
        slug: "real-estate-description",
        contentType: FormatterMode.Web,
        options: {
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: true,
        },
        text: `Modern Apartment in City Center

This renovated two-bedroom apartment offers a bright open-plan living area with large windows and a west-facing balcony. The interior combines modern finishes with practical storage for comfortable daily living.

Property Highlights
- Built-in kitchen appliances with quartz worktops.
- Two spacious bedrooms with custom wardrobes.
- Walk-in shower and underfloor bathroom heating.

Location Benefits
- Five-minute walk to tram and metro connections.
- Nearby schools, supermarkets, and fitness centers.
- Includes one secure parking space and private storage.`,
    },
    {
        id: "job-description",
        label: "Job Description",
        slug: "job-description",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: false,
        },
        text: `Frontend Developer

We are looking for a Frontend Developer to build and improve user-facing features in our web platform. You will collaborate with product, design, and backend teams to deliver reliable and accessible interfaces.

Key Responsibilities
- Build reusable React and TypeScript components.
- Improve rendering performance and loading speed.
- Review code and contribute to technical planning.

Requirements
- Strong experience with React, TypeScript, and modern CSS.
- Ability to translate design specs into production UI.
- Experience with testing tools and component libraries is a plus.`,
    },
];
